import { useCallback, useMemo } from 'react';
import { useSaudiDateFilter } from '../context/SaudiDateFilterContext';

/**
 * List pages: read/write the global header date filter (SaudiHeader presets bar).
 */
export function useSaudiListDateRange() {
  const { preset, range, onPresetChange } = useSaudiDateFilter();

  const dateRange = useMemo(
    () => ({
      start: range?.start ?? null,
      end: range?.end ?? null,
    }),
    [range?.start, range?.end],
  );

  const setDateRange = useCallback(
    (next) => {
      const start = next?.start ?? null;
      const end = next?.end ?? null;
      onPresetChange('custom', { start, end });
    },
    [onPresetChange],
  );

  return { dateRange, setDateRange, preset, onPresetChange };
}

export default useSaudiListDateRange;
